import { render, staticRenderFns } from "./timindexThree.vue?vue&type=template&id=4ac80566&scoped=true"
import script from "./timindexThree.vue?vue&type=script&lang=js"
export * from "./timindexThree.vue?vue&type=script&lang=js"
import style0 from "./timindexThree.vue?vue&type=style&index=0&id=4ac80566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac80566",
  null
  
)

export default component.exports